import React from "react";
import HelpMePage from "../components/HelpMePage";
import Head from "next/head";

const Helpme = () => {
  const titleParser = "Найти донора - DonorSearch";
  const description =
    "Создайте карточку реципиента и найдите необходимое количество доноров как можно скорее!";
  return (
    <>
      <Head>
        <title>{titleParser}</title>
        <meta property="og:title" content={titleParser} />
        <meta property="title" content={titleParser} />
        <meta property={"description"} content={description} />
        <meta name={"description"} content={description} />
        <meta property={"og:description"} content={description} />
        <meta name={"og:description"} content={description} />
        <meta property="og:description" content={description} />
        <meta name="description" content={description} />
      </Head>
      <HelpMePage />
    </>
  );
};

export default Helpme;
